import { 
	call, 
	put, 
	takeEvery 
} from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";

export default function* activitiesCount(action: ActionInterface): any {
  try {
		let request = "events?first_item=0&last_item=0&event_type_ids=34&removed=0&reacted=0";
 
    const res = yield call(Http.get, request);

    yield put({
      type: Constants.GLOBAL_EVENTS_SAVE_LIST_SUCCESS,
      payload: {
        activitiesEventsCount: res.data.events.count
      }
    });

    yield put({
      type: Constants.GLOBAL_ACTIVITIES_COUNT_SUCCESS
    });
  } catch (err) {
    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchActivitiesCount() {
  yield takeEvery(Constants.GLOBAL_ACTIVITIES_COUNT, activitiesCount);
}
